var _linearGradient, _linearGradient2, _linearGradient3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllusSolicError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 247 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: -5126.67,
    y1: 619.14,
    x2: -5126.67,
    y2: 619.15,
    gradientTransform: "matrix(143.65, 0, 0, -185.04, 736549.69, 113571.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: -4800.77,
    y1: 773.26,
    x2: -4800.77,
    y2: 773.32,
    gradientTransform: "matrix(13.66, 0, 0, -5.62, 65671.94, 3279.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3-2",
    x1: -5048.32,
    y1: 605.66,
    x2: -5048.29,
    y2: 605.66,
    gradientTransform: "matrix(36.13, 0, 0, -38.55, 181613.71, 23418.12)",
    xlinkHref: "#Degradado_sin_nombre_3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.2,
    y: 53.85,
    width: 31.59,
    height: 33.7,
    rx: 1.94,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1304",
    "data-name": "Grupo 1304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_677",
    "data-name": "Grupo 677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_597",
    "data-name": "Grupo 597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2228",
    "data-name": "Trazado 2228",
    d: "M123.86,15.93A102.37,102.37,0,1,1,21.51,118.32v0A102.37,102.37,0,0,1,123.86,15.93Z",
    style: {
      fill: "#e5dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "undraw_account_490v",
    "data-name": "undraw account 490v"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_603",
    "data-name": "Rect\\xE1ngulo 603",
    x: 52.92,
    y: 36.27,
    width: 143.65,
    height: 185.04,
    style: {
      fill: "url(#Degradado_sin_nombre_2)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_602",
    "data-name": "Rect\\xE1ngulo 602",
    x: 60.6,
    y: 43.01,
    width: 139.06,
    height: 180.93,
    style: {
      fill: "#9b8bbc",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_603-2",
    "data-name": "Rect\\xE1ngulo 603-2",
    x: 54.81,
    y: 38.64,
    width: 139.86,
    height: 180.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_658",
    "data-name": "Grupo 658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_655",
    "data-name": "Grupo 655"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_617",
    "data-name": "Rect\\xE1ngulo 617",
    x: 137.28,
    y: 179.58,
    width: 43.13,
    height: 4.55,
    style: {
      fill: "#48e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_620",
    "data-name": "Rect\\xE1ngulo 620",
    x: 67.4,
    y: 179.4,
    width: 13.66,
    height: 5.62,
    style: {
      fill: "url(#Degradado_sin_nombre_3)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_625",
    "data-name": "Rect\\xE1ngulo 625",
    x: 67,
    y: 192.94,
    width: 37.14,
    height: 6.36,
    style: {
      fill: "#7644c9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_657",
    "data-name": "Grupo 657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_656",
    "data-name": "Grupo 656"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_615",
    "data-name": "Rect\\xE1ngulo 615",
    x: 67.93,
    y: 106.58,
    width: 112.47,
    height: 5.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_616",
    "data-name": "Rect\\xE1ngulo 616",
    x: 67.93,
    y: 118.99,
    width: 43.13,
    height: 5.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_618",
    "data-name": "Rect\\xE1ngulo 618",
    x: 67.93,
    y: 131.42,
    width: 112.47,
    height: 5.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_619",
    "data-name": "Rect\\xE1ngulo 619",
    x: 67.93,
    y: 143.83,
    width: 112.47,
    height: 5.7,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_621",
    "data-name": "Rect\\xE1ngulo 621",
    x: 67.93,
    y: 156.26,
    width: 12.86,
    height: 5.7,
    style: {
      fill: "#7644c9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_622",
    "data-name": "Rect\\xE1ngulo 622",
    x: 117.4,
    y: 156.26,
    width: 12.86,
    height: 5.7,
    style: {
      fill: "#48e0ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_623",
    "data-name": "Rect\\xE1ngulo 623",
    x: 167.54,
    y: 156.26,
    width: 12.86,
    height: 5.7,
    style: {
      fill: "#48e0ff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_662",
    "data-name": "Grupo 662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_668",
    "data-name": "Rect\\xE1ngulo 668",
    d: "M70.8,51.43h30.4a2.87,2.87,0,0,1,2.87,2.87h0V87.11A2.88,2.88,0,0,1,101.2,90H70.8a2.86,2.86,0,0,1-2.86-2.86h0V54.3a2.86,2.86,0,0,1,2.84-2.87Z",
    style: {
      fill: "url(#Degradado_sin_nombre_3-2)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_669",
    "data-name": "Rect\\xE1ngulo 669",
    x: 70.2,
    y: 53.85,
    width: 31.59,
    height: 33.7,
    rx: 1.94,
    style: {
      fill: "#7644c9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_675",
    "data-name": "Grupo 675"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1304-2",
    "data-name": "Grupo 1304-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_674",
    "data-name": "Grupo 674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1297",
    "data-name": "Trazado 1297",
    d: "M99.82,83.47c-3.09-1.73-8.49-3.27-9.66-4.43V77.11s1.64-.68,2-4.73c0,0,.58,0,.58-.77a18.74,18.74,0,0,1,.78-2.33c.19-.57.19-1.29-.78-1.16a.67.67,0,0,0,0-.2h0v-.08a9.34,9.34,0,0,0,.27-1h0c.08-.56.16-1.3.25-2A4.75,4.75,0,0,0,91,60a12.51,12.51,0,0,0-7.41-1.49c-1.91.16-1.93,1.29-1.93,1.29-5.17,1-2.9,8.32-2.9,8.32-1-.2-1,.56-.77,1.16a14.56,14.56,0,0,1,.77,2.31c0,.78.59.78.59.78.38,4,2,4.73,2,4.73V79c-1.17,1.16-6.57,2.7-9.66,4.44-1.93,1.08-2.5,4.11-2.66,6.25,4.48,4.2,10.52,11.45,17.14,11.45a28.31,28.31,0,0,0,17.37-6.62C103.48,92.47,102,84.69,99.82,83.47Z",
    style: {
      fill: "#fff"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_676",
    "data-name": "Grupo 676"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_610-2",
    "data-name": "Rect\\xE1ngulo 610-2",
    x: 115.76,
    y: 55.59,
    width: 50.33,
    height: 5.59,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_611-2",
    "data-name": "Rect\\xE1ngulo 611-2",
    x: 115.76,
    y: 79.21,
    width: 50.33,
    height: 5.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_612-2",
    "data-name": "Rect\\xE1ngulo 612-2",
    x: 115.76,
    y: 67.4,
    width: 29.33,
    height: 5.59,
    style: {
      fill: "#7644c9",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1278",
    "data-name": "Grupo 1278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25",
    "data-name": "Elipse 25"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98",
    "data-name": "Elipse 98",
    cx: 25.14,
    cy: 179.54,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25_4_2",
    "data-name": "Elipse 25 4 2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-2",
    "data-name": "Elipse 98-2",
    cx: 14.13,
    cy: 161.83,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25_4_3",
    "data-name": "Elipse 25 4 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-3",
    "data-name": "Elipse 98-3",
    cx: 9.21,
    cy: 141.95,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25_4_4",
    "data-name": "Elipse 25 4 4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-4",
    "data-name": "Elipse 98-4",
    cx: 6.86,
    cy: 120.8,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25_4_5",
    "data-name": "Elipse 25 4 5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-5",
    "data-name": "Elipse 98-5",
    cx: 8.67,
    cy: 100.02,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1278-2",
    "data-name": "Grupo 1278-2",
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25-2",
    "data-name": "Elipse 25-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-2-2",
    "data-name": "Elipse 98-2-2",
    cx: 221.86,
    cy: 179.54,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25_4_2-2",
    "data-name": "Elipse 25 4 2-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-2-3",
    "data-name": "Elipse 98-2-3",
    cx: 232.87,
    cy: 161.83,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25_4_3-2",
    "data-name": "Elipse 25 4 3-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-3-2",
    "data-name": "Elipse 98-3-2",
    cx: 237.79,
    cy: 141.95,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25_4_4-2",
    "data-name": "Elipse 25 4 4-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-4-2",
    "data-name": "Elipse 98-4-2",
    cx: 240.14,
    cy: 120.8,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_25_4_5-2",
    "data-name": "Elipse 25 4 5-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98-5-2",
    "data-name": "Elipse 98-5-2",
    cx: 238.33,
    cy: 100.02,
    r: 4.63,
    style: {
      fill: "#e6dbee"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1241",
    "data-name": "Grupo 1241"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_25-2-2",
    "data-name": "Elipse 25-2",
    cx: 186.35,
    cy: 204.45,
    r: 26.6,
    style: {
      fill: "#f4f4fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1854",
    "data-name": "Trazado 1854",
    d: "M205.16,185.63a26.6,26.6,0,1,0,0,37.64,26.6,26.6,0,0,0,0-37.64Zm-18.9,26.68a2.74,2.74,0,1,1-2.74,2.74h0A2.74,2.74,0,0,1,186.26,212.31Z",
    style: {
      fill: "#f08c61"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_877",
    "data-name": "Rect\\xE1ngulo 877",
    x: 158.85,
    y: 179.27,
    width: 54.11,
    height: 54.11,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.8,208.53h-1.06a1.85,1.85,0,0,1-1.74-1.85s-.8-6.48-.8-7.58-.1-5.61-.1-5.61a1.89,1.89,0,0,1,1.75-2.08h2.83a1.88,1.88,0,0,1,1.74,2.08s-.12,4.68-.12,5.68c0,1.19-.76,7.51-.76,7.51A1.85,1.85,0,0,1,186.8,208.53Z",
    style: {
      fill: "#f4f4fb"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusSolicError);
export default __webpack_public_path__ + "static/media/illus_solic_error.dd4357ae571465cfcc6fe4b82af0b954.svg";
export { ForwardRef as ReactComponent };